// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1au4s","header":"MessagesList_header__14EoS","chat":"MessagesList_chat__2Ep4g"};